export const EXPORT_BUILDINGS = 'EXPORT_BUILDINGS';

export function tableDataExport(status) {
  return {
    type: EXPORT_BUILDINGS,
    exportStatus: status,
  };
}
